// extracted by mini-css-extract-plugin
export default {"categories":"AidifyChatbot_categories__SJfB7","types":"AidifyChatbot_types__w6YIy"};